import { UseMutationResult } from 'react-query'
import { Product } from '../../openapi/api'
import { useApi } from '../ApiProvider'

export const useUpdateProduct = (productId: string): UseMutationResult<string, Error, Product> => {
  const { useProductUpdateMutation } = useApi()
  return useProductUpdateMutation(productId)
}
